import { inject } from "aurelia-framework";
import { HttpClient } from "aurelia-http-client";

@inject(HttpClient)
export class TestimonialFromAPI {
  constructor(http) {
    this.http = http;
  }

  submit(code, data, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http
      .post("api/testimonialForm/create/"+code, data)
      .then((data) => {
        if (data.isSuccess) {
          if (data.response) {
            var json = JSON.parse(data.response);

            if (json.hasOwnProperty("testimonialRequest")) {
              successCallback(json.testimonialRequest);
            }

            if (json.hasOwnProperty("error")) errorCallback(json.error);
          } else successCallback();
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  validateCode(code, successCallback, errorCallback) {

    this.http = this.http.configure(x => {
        x.withHeader('Content-Type', 'application/json');

    });

    this.http.get('api/testimonialForm/validate/' + code)
        .then(data => {
            if (data.isSuccess) {
                var json = JSON.parse(data.response);
                if(json.hasOwnProperty("valid"))
                    successCallback(true);
                if(json.hasOwnProperty("error"))
                    errorCallback(json.error);
            }
            else {
                errorCallback(data.statusText);
            }
        });

}

}
